import React, { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Awards from './components/Awards/Awards';
import Footer from './components/Footer/Footer';
import AboutUs from './components/AboutUs/AboutUs';
// Temporarily disabled until LinkedIn integration is ready
// import News from './components/News/News';
// import NewsArticle from './components/News/NewsArticle';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AwardsPage from './components/AwardsPage/AwardsPage';
import Sponsors from './components/Sponsors/Sponsors';
import Projects from './components/Projects/Projects';
import ProjectDetail from './components/Projects/ProjectDetail';
import { ProjectsPreview } from './components/Projects/Projects';
import IntegrAI from './components/IntegrAI/IntegrAI';
import ConsentBanner from './components/ConsentBanner/ConsentBanner';
import PrivacyNotice from './components/PrivacyNotice/PrivacyNotice';
import SeoManager from './components/Seo/SeoManager';
import NotFound from './components/NotFound/NotFound';
import { trackAnalyticsEvent } from './services/analytics';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    void trackAnalyticsEvent('page_view', {
      page_path: pathname,
      page_title: document.title,
    });
  }, [pathname]);

  return null;
};

function FadeInWrapper() {
  const location = useLocation();

  useEffect(() => {
    const elements = document.querySelectorAll('.fade-in');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0 });

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [location]);

  return (
    <main id="main-content" aria-label="INTEGRA 3646 website content">
      <Routes>
        <Route
          path="/"
          element={(
            <>
              <div className="fade-in"><Hero /></div>
              <div className="fade-in">
                <ProjectsPreview />
              </div>
              <div className="video-container fade-in">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/ynGnmiHkkFw?si=6t45AXxj604bxmlR"
                  title="INTEGRA 3646 featured team video"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="fade-in"><Awards /></div>
              <div className="fade-in">
                <Sponsors compact />
              </div>
            </>
          )}
        />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/awards" element={<AwardsPage />} />
        <Route path="/sponsors" element={<Sponsors />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:projectIdOrSlug" element={<ProjectDetail />} />
        <Route path="/integrai" element={<IntegrAI />} />
        <Route path="/privacy" element={<PrivacyNotice />} />
        <Route path="*" element={<NotFound />} />
        {/* Temporarily disabled until LinkedIn integration is ready */}
        {/*<Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsArticle />} />*/}
      </Routes>
    </main>
  );
}

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <span className="scroll-to-top__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M12 19V5" />
          <path d="M6.5 10.5 12 5l5.5 5.5" />
        </svg>
      </span>
    </button>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <SeoManager />
        <Header />
        <ScrollToTop />
        <FadeInWrapper />
        <Footer />
        <ConsentBanner />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;
